// 将一个数组按一定长度分割成多个数组，结果返回一个二维数组，每一项为一个分割块
export function sliceArray(array: any[], sliceLength: number) {
    const { allSlice } = array.reduce((acc, curr) => {
        const { allSlice } = acc;
        let { currentSlice } = acc;
        if (currentSlice.length === 0) {
            allSlice.push(currentSlice);
        }
        if (currentSlice.length < sliceLength) {
            currentSlice.push(curr);
        } else {
            currentSlice = [curr];
            acc.currentSlice = currentSlice;
            allSlice.push(currentSlice);
        }
        return acc;
    }, {
        allSlice: [] as any[][],
        currentSlice: [] as any[],
    });
    return allSlice;
}

